import React, { memo, useContext } from 'react';
import { Segment, Table, TableProps } from 'tea-component';
import { getColumns } from './utils/common';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import useTableList from './hooks/useTableList';
import { context as Context } from '@gp/components/Context';
import './index.scss';

const { autotip, sortable } = Table.addons;

const LOADING = false;

interface MergeableTableProps {
  [keyName: string]: any;
}

function TableForPDFDownload(props: MergeableTableProps) {
  const {} = props;

  const {
    isAllDatasResLoading: loading,
    allDatas: data,
    filter,
    sorts,
  } = useContext<IAllDataContextTypesForPDFDownload>(Context) || {};

  const { records, colList } = useTableList({
    sourceData: data,
    type: filter?.type,
  });

  // 表格使用到的插件
  const addons = [
    sortable({
      columns: colList || [],
      value: sorts ? [sorts] : [],
    }),
    autotip({
      isLoading: LOADING,
      hideIcon: !LOADING, //loading状态显示图标，其他情况不显示
      emptyText: <span style={{ color: '#444' }}>No data yet.</span>,
      style: {
        height: 172,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        margin: '0 auto',
      },
    }),
  ];

  return (
    <section className="dbg-studio-overall-details-people-headcounts-table-content">
      {loading ? (
        <Loading loading style={{height: 260, marginTop: 20}} />
      ) : !data || !data?.dataList?.length ? (
        <NoData height={200} constomStyle={{ fontSize: 14 }} />
      ) : (
        <Table
          className="dbg-common-table people-headcounts-table-list-table"
          style={{marginTop: 0}}
          verticalTop
          // bordered="all"
          records={records}
          recordKey="uniqueId"
          columns={getColumns(colList, filter?.type) as TableProps['columns']}
          addons={addons}
        />
      )}
    </section>
  );
}

TableForPDFDownload.defaultProps = {};

export default memo(TableForPDFDownload);
